import placementDrawerSections from '../config/placementDrawerNavigationItems';

export const findSection = slug => {
  return placementDrawerSections.find(section => {
    return section.slug === slug;
  });
};
